<template>
    <b-media vertical-align="center">
        <avatar :size="60" :src="target.owner.picture" :username="target.owner.name" slot="aside" class="d-down-none" />
        <div>
            <p v-if="!nameLink" class="mb-0 text-small-sm-down text-justify">
                <strong>{{ target.title }}</strong>
            </p>
            <p v-if="nameLink" class="mb-0 text-small-sm-down text-justify">
                <router-link :to="`/v2/target/targets/view/${target.id}`">
                    <strong>{{ target.title }}</strong>
                </router-link>
            </p>
            <div class="d-flex justify-content-between">
                <p class="mb-0">
                    <small class="text-muted">{{ target.owner.name }}</small>
                </p>
                <p v-if="showProportion" class="mb-0 text-right">
                    <small>
                        <strong>{{ getProportion }}</strong>
                    </small>
                </p>
            </div>
            <div>
                <progress-bar :value="target.progress" :color="target.range" />
            </div>
            <div class="d-flex justify-content-between">
                <p class="mb-0 mt-2">
                    <b-badge class="mr-2" :variant="getStatusVariant">
                        {{ getStatusTitle }}
                    </b-badge>
                    <b-badge v-if="target.section" variant="light" class="mr-2">
                        {{ target.section }}
                    </b-badge>
                    <b-badge v-if="target.hasTriggerGoal" variant="light">
                        {{ $t('profile.targetsTable.triggerGoal') }}
                    </b-badge>
                    <b-badge v-if="target.level" class="secondary-color">
                        {{ $t(`groupLevel.${target.level}`) }}
                    </b-badge>
                </p>
                <p class="mb-0 ml-auto">
                    <span class="text-muted">
                        {{ getStatusProgress }}
                    </span>
                </p>
            </div>
        </div>
    </b-media>
</template>

<script>
import Avatar from 'vue-avatar'
import ProgressBar from '@/views/components/progress-bar/ProgressBar'
import { formatNumber, formatPercentage } from '@/lib/utils'
import i18n from '@/i18n'

export default {
    name: 'IndicatorProgress',
    props: {
        target: {
            type: Object,
            required: true,
        },
        nameLink: {
            type: Boolean,
            required: false,
        },
    },
    components: {
        Avatar,
        ProgressBar,
    },
    methods: {
        formatNumber(number, digits = 10) {
            if (isNaN(number)) number = 0

            return formatNumber(number, digits)
        },
        formatPercentage(number) {
            if (isNaN(number)) {
                number = 0
            }
            return formatPercentage(number)
        },
        formatNumberByPolarity(target) {
            if (target.yearToDate.title == 'accumulated') {
                if (!target.polarity && target.initialValue > target.target) {
                    const diffValue = target.initialValue - target.target
                    return formatNumber(diffValue, 2)
                }
            }

            return formatNumber(target.target, 2)
        },
    },
    computed: {
        showProportion() {
            return this.target.lastCheckInValue !== null && this.target.target !== null
        },
        getProportion() {
            let target
            if (this.target.visualizationType == 'year_to_date') {
                target = formatNumber(this.target.kpiCheckins.expectationByVisualizationType)
            } else {
                target = this.formatNumberByPolarity(this.target)
            }
            return i18n.t('profile.targetsTable.outOf', {
                lastCheckInValue: formatNumber(this.target.lastCheckInValue, 2),
                target,
            })
        },
        getStatusVariant() {
            return this.target.status == 'active' ? 'primary' : 'success'
        },
        getStatusTitle() {
            return i18n.t(`targets.status.${this.target.status}`).toLowerCase()
        },
        getStatusProgress() {
            return this.target.progress ? formatPercentage(this.target.progress, 2) + '%' : '-'
        },
    },
}
</script>

<style lang="sass">
.secondary-color
    background-color: #57d9ff
    color: white
</style>
